/* eslint-disable camelcase */
import deduceProviderAccountDetails from '~/components/payment/deposit/data/deduce-provider-details';
import currencyFormatter from '~/libs/currency-formatter';

import { NewQDLogoContainer } from '~/components/payment/quick-deposit-beta/components-v2/styles';

import {
	ADYEN_IDEAL,
	ADYEN_MOBILEPAY,
	CREDITCARD,
	IconMap,
	LogoMap,
	PAYPAL,
	TRUSTLY
} from '~/components/payment/quick-deposit-beta/utils/constants';

import {
	AccountInfoName,
	IconContainer,
	LogoContainer,
	NewQDIconContainer
} from '~/components/payment/quick-deposit-beta/utils/qd-styled-utils';

export const getLogo = (provider, icon, newQDContainer) => {
	const providerNameKey = provider?.paymentMethodNameTextKey;
	let Logo;
	let Container;

	if (icon) {
		Logo = IconMap[providerNameKey] || IconMap.DEFAULT;
		Container = newQDContainer ? NewQDIconContainer : IconContainer;
	} else {
		Logo = LogoMap[providerNameKey] || LogoMap.DEFAULT;
		Container = newQDContainer ? NewQDLogoContainer : LogoContainer;
	}

	return (
		<Container>
			<Logo className={providerNameKey?.toLowerCase()} />
		</Container>
	);
};

export const renderAccountDetails = (provider, component) => {
	const { playerCardData, extraParameters } = provider || {};

	switch (provider?.paymentMethodName) {
		case TRUSTLY: {
			return {
				accountInfo: deduceProviderAccountDetails(extraParameters?.accountNumber),
				selectedBank: extraParameters?.bankName
			};
		}

		case ADYEN_IDEAL: {
			return {
				accountInfo: deduceProviderAccountDetails(extraParameters?.accountNumber),
				selectedBank: extraParameters?.bankName
			};
		}

		case CREDITCARD: {
			return { accountInfo: deduceProviderAccountDetails(playerCardData?.cardNo) };
		}

		case ADYEN_MOBILEPAY: {
			return { accountInfo: deduceProviderAccountDetails(extraParameters?.phoneNumber) };
		}

		case PAYPAL: {
			return {
				accountInfo: component === 'button' ? '' : deduceProviderAccountDetails(extraParameters?.accountNumber)
			};
		}

		default: {
			return {};
		}
	}
};

export const providerLimitInfo = (providerLimitsData, currency, locale) => {
	if (!providerLimitsData) {
		return {};
	}

	const { depositLimitData, paymentProviderData } = providerLimitsData;
	const {
		PARAM_MAX_OPERATION,
		PARAM_MIN_OPERATION,
		PARAM_RESPONSIBLE_GAMING_LIMIT,
		PARAM_RESPONSIBLE_GAMING_MAX_DEPOSIT,
		PARAM_SCHUFA_CONSENT_NEEDED: playerConsentNeeded,
		PARAM_SCHUFA_MONTHLY_REMAINING_AMT: remainingMonthlyLimit,
		responsibleGamingLimitType
	} = depositLimitData || {};
	const { PARAM_PAYMENT_METHOD_ID, PARAM_PAYMENT_PROVIDER_ID } = paymentProviderData || {};
	// Take minimum of 2 values
	const sum_max = Math.floor(Math.min(Number(PARAM_MAX_OPERATION), Number(PARAM_RESPONSIBLE_GAMING_MAX_DEPOSIT)));
	const sum_min = Number(PARAM_MIN_OPERATION);
	const sum_limit = Number(PARAM_RESPONSIBLE_GAMING_LIMIT);
	const paymentMethodId = Number(PARAM_PAYMENT_METHOD_ID);
	const providerId = Number(PARAM_PAYMENT_PROVIDER_ID);
	const schufaLimitHit = remainingMonthlyLimit !== '' && Number(remainingMonthlyLimit) < Number(sum_min);

	const formattedLimit = currencyFormatter.format(sum_limit, currency, locale);
	const formattedSumMin = currencyFormatter.format(sum_min, currency, locale);
	const formattedSumMax = currencyFormatter.format(sum_max, currency, locale);

	const LimitsData = {
		sum_max,
		sum_min,
		sum_limit,
		formattedLimit,
		formattedSumMin,
		formattedSumMax,
		responsibleGamingLimitType,
		playerConsentNeeded,
		remainingMonthlyLimit,
		schufaLimitHit,
		paymentMethodId,
		providerId
	};
	return LimitsData;
};

export const getAccountInfo = provider => {
	const { accountInfo, selectedBank } = renderAccountDetails(provider);
	if (accountInfo || selectedBank) {
		return (
			<>
				{selectedBank ? <AccountInfoName>{selectedBank}&nbsp;</AccountInfoName> : ''}
				{accountInfo || ''}
			</>
		);
	}
	return false;
};
